import React from "react";

import { Card, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import Progressive from "./Progressive.png";

const styles = {
	typo: {
		paddingInlineStart: "0px",
	},
	card: {
		height: "100%",
		textAlign: "center",
	},
};

function ProgressiveModeTab(props) {
	const { classes } = props;
	return (
		<Card className={classes.card}>
			<Typography color="primary" style={{ paddingTop: "30px" }}>
				<img src={Progressive} alt="Progressive" style={{ maxWidth: "100%", height: "auto", margin: "0px auto", padding: "110px 30px 15px", textAlign: "center", display: "block" }} />
				{/* <span style={{ textAlign: "center" }}>Welcome to C-Zentrix</span> */} Waiting for call...
			</Typography>

			{/* <Typography color="textSecondary">
				<span>Message from C-Zentrix.</span>
			</Typography> */}

			{/* <Typography color="primary" style={{ paddingTop: "30px" }}>
				Waiting for call...
			</Typography> */}
		</Card>
	);
}

export default withStyles(styles)(ProgressiveModeTab);
